module.exports = __webpack_public_path__ + "img/PMA_Logo.98a84cc8.svg";